// extracted by mini-css-extract-plugin
export default {"root":"FreemiumUnlimitedSpaceModal__root--1tgr7"};